import { useEffect, useMemo } from "react";
import Select from "react-select";
import { Controller, useWatch } from "react-hook-form";

import { customStyles, customErrorStyles } from "./optionsSelectWithSearch";

import innerStyles from "./selectWithSearchUniversal.module.css";

export default function SelectWithSearchUniversal({
  inputProps,
  dataForm,
  control,
  externalStyles,
  setValue,
  mode,
  errors = {},
  clearErrors,
  getValues,
  setError,
}) {
  const watchedValue = useWatch({ control, name: inputProps.key });

  const getValueForSelectSearch = (value) => {
    return inputProps.options?.find((item) => item.value === value) || "";
  };

  useEffect(() => {
    if (watchedValue !== undefined) {
      setValue(inputProps.key, watchedValue);
    }
    if (!!watchedValue && clearErrors) {
      clearErrors(inputProps.key);
    }
  }, [watchedValue]);

  return (
    <div className={externalStyles?.[`box-${inputProps.key}`]}>
      <label className={innerStyles?.["label"]}>
        {inputProps.label}
        {inputProps.required && mode !== "view" && <span className={innerStyles["red-dot"]}>*</span>}
      </label>
      <Controller
        name={inputProps.key}
        control={control}
        rules={{
          validate: (value) => {
            if (typeof value === "boolean") {
              return true;
            } else {
              if (inputProps.required) {
                if (value !== undefined) {
                  if (inputProps.hasOwnProperty("customValidation")) {
                    return inputProps.customValidation(
                      value,
                      getValues && getValues(),
                      setError,
                      clearErrors,
                    );
                  } else return true;
                }
                return `Заполните поле`;
              } else {
                if (value === null) {
                  return true;
                }
              }
            }

            // Проверка наличия customValidation

            return true;
          },
        }}
        render={({ field: { onChange, value } }) => (
          <>
            <Select
              className={innerStyles["form-select"]}
              classNamePrefix="react-select"
              id={inputProps.key}
              isDisabled={inputProps.disabled || mode === "view"}
              isSearchable={inputProps.isSearchable}
              // value={getValueForSelectSearch(value) || memoizedValue}
              noOptionsMessage={() => "Нет данных"}
              value={getValueForSelectSearch(watchedValue)}
              onChange={(newValue) => {
                setValue(inputProps.key + "Name", newValue.label);
                onChange(newValue.value);
              }}
              placeholder={inputProps.placeholder || "Выберите"}
              options={inputProps.options}
              styles={errors[inputProps.key] ? customErrorStyles : customStyles}
            />
            {errors[inputProps.key] && (
              <div className={innerStyles["error-text"]}>{errors[inputProps.key].message}</div>
            )}
          </>
        )}
      />
    </div>
  );
}
